import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Table,
  Modal,
  ModalBody,
  FormGroup,
  Label,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import SummaryCards from "components/SummaryCards";
import { PageSubHeader } from "../../components/CommonLayouts/PageSubHeader";
import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";
import CustomPagination from "components/CustomPagination";
import NewJobPost from "./NewJobPost";
import {
  GET_ALL_JOBS,
  TOTAL_JOB_COUNT,
  GET_STATUS_JOBS_ID,
} from "constants/api_constants";
import { get, post, put } from "helpers/api_helper";

// Ensure GET_STATUS_JOBS_ID is defined in api_constants.js:
// export const GET_STATUS_JOBS_ID = (id, status) => `/recruitment/api/jobs/setJobStatus?status=${status}&id=${id}`;

const JobPostings = () => {
  const navigate = useNavigate();
  const [showNewJobPostModal, setShowNewJobPostModal] = useState(false);
  const [apiStatus, setApiStatus] = useState({
    loading: false,
    error: "",
    errorJobId: null,
  });
  const [jobLoading, setJobLoading] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [jobPostingData, setJobPostingData] = useState([]);
  console.log("jobPostingData", jobPostingData);

  const [searchQuery, setSearchQuery] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [jobsCount, setJobsCount] = useState({
    total: 0,
    active: 0,
    inactive: 0,
  });
  const timerRef = useRef(null);

  const toggleModal = () => {
    setShowNewJobPostModal((prev) => !prev);
  };

  const fetchJobCounts = useCallback(async () => {
    try {
      setApiStatus({ loading: true, error: "", errorJobId: null });
      const countData = await get(TOTAL_JOB_COUNT);
      setJobsCount(countData?.data || { total: 0, active: 0, inactive: 0 });
      setApiStatus({ loading: false, error: "", errorJobId: null });
    } catch (error) {
      console.error("Error fetching job counts:", error, error.response?.data);
      setApiStatus({
        loading: false,
        error: "Failed to fetch job counts",
        errorJobId: null,
      });
    }
  }, []);

  const fetchJopPosting = useCallback(
    async (
      query = "",
      department = "",
      location = "",
      status = "",
      page = 1
    ) => {
      try {
        setApiStatus({ loading: true, error: "", errorJobId: null });
        const response = await post(GET_ALL_JOBS, {
          searchKeyword: query,
          department: department || "",
          jobLocation: location || "",
          orderBy: "jobTitle",
          status: status === "" ? null : status,
          page: page - 1,
          pageSize: 10,
        });

        setJobPostingData(response?.data?.data || []);
        setTotalPages(response?.data?.totalPages || 0);
        setApiStatus({ loading: false, error: "" });
      } catch (error) {
        console.error("Error fetching job postings:", error);
        setApiStatus({ loading: false, error: "Failed to fetch job postings" });
      }
    },
    []
  );
  console.log("job", jobPostingData);

  //       setJobPostingData(response?.data?.data || []);
  //       setTotalPages(response?.data?.totalPages || 0);
  //       setApiStatus({ loading: false, error: "", errorJobId: null });
  //     } catch (error) {
  //       console.error("Error fetching job postings:", error, error.response?.data);
  //       setApiStatus({ loading: false, error: "Failed to fetch job postings", errorJobId: null });
  //     }
  //   },
  //   []
  // );

  const toggleJobStatus = useCallback(
    async (jobId) => {
      try {
        setJobLoading((prev) => ({ ...prev, [jobId]: true }));
        setApiStatus({ loading: false, error: "", errorJobId: null });

        const job = jobPostingData.find((j) => j.id === jobId);
        if (!job) {
          throw new Error("Job not found");
        }
        const currentStatus = job.status;
        const newStatus = currentStatus === 1 ? 0 : 1;

        if (![0, 1].includes(newStatus)) {
          throw new Error("Invalid status value");
        }

        await put(GET_STATUS_JOBS_ID(jobId, newStatus), { status: newStatus });

        setJobPostingData((prev) =>
          prev.map((j) => (j.id === jobId ? { ...j, status: newStatus } : j))
        );

        await fetchJobCounts();

        setJobLoading((prev) => ({ ...prev, [jobId]: false }));
        setApiStatus({ loading: false, error: "", errorJobId: null });
      } catch (error) {
        console.error(
          "Error updating job status:",
          error,
          error.response?.data
        );
        setJobLoading((prev) => ({ ...prev, [jobId]: false }));
        setApiStatus({
          loading: false,
          error: `Failed to update job status: ${
            error.response?.data?.message || error.message
          }`,
          errorJobId: jobId,
        });
      }
    },
    [jobPostingData, fetchJobCounts]
  );

  useEffect(() => {
    fetchJobCounts();
    fetchJopPosting();
  }, [fetchJobCounts, fetchJopPosting]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      fetchJopPosting(
        searchQuery,
        departmentFilter,
        locationFilter,
        statusFilter,
        page
      );
    },
    [
      fetchJopPosting,
      searchQuery,
      departmentFilter,
      locationFilter,
      statusFilter,
    ]
  );

  const handleSearchQuery = (e) => {
    const query = e.target.value || "";
    setSearchQuery(query);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      setCurrentPage(1);
      fetchJopPosting(query, departmentFilter, locationFilter, statusFilter, 1);
    }, 300);
  };

  const handleDepartmentFilter = (e) => {
    const department = e.target.value;
    setDepartmentFilter(department);
    setCurrentPage(1);
    fetchJopPosting(searchQuery, department, locationFilter, statusFilter, 1);
  };

  const handleLocationFilter = (e) => {
    const location = e.target.value;
    setLocationFilter(location);
    setCurrentPage(1);
    fetchJopPosting(searchQuery, departmentFilter, location, statusFilter, 1);
  };

  const handleStatusFilter = (e) => {
    const value = e.target.value;
    const status = value === "open" ? 1 : value === "closed" ? 0 : "";
    setStatusFilter(value);
    setCurrentPage(1);
    fetchJopPosting(searchQuery, departmentFilter, locationFilter, status, 1);
  };

  const getStatusLabelAndColor = (status) => {
    switch (status) {
      case 1:
        return { label: "", color: "text-success fw-semibold" };
      case 0:
        return { label: "", color: "text-secondary fw-semibold" };
      default:
        return { label: status, color: "text-muted" };
    }
  };

  const summaryData = [
    {
      iconClass: "fas fa-briefcase text-primary",
      label: "Total Jobs Posted",
      value: jobsCount.total,
    },
    {
      iconClass: "fas fa-check-circle text-success",
      label: "Active Jobs",
      value: jobsCount.active,
    },
    {
      iconClass: "fas fa-times-circle text-danger",
      label: "Inactive Jobs",
      value: jobsCount.inactive,
    },
  ];

  //   return (
  //     <div className="page-content">
  //       <PageSubHeader
  //         heading={"View Job Postings"}
  //         routePath={"Home"}
  //         pageName={"Job Postings"}
  //       />
  //       <Container fluid className="py-0 px-0">
  //         <Row className="px-4 py-4">
  //           <SummaryCards data={summaryData} />
  //           <Row className="align-items-center">
  //             <Col className="d-flex p-2 mx-2">
  //               <InputGroup
  //                 size="sm"
  //                 className="elbert-search-group"
  //                 style={{ width: "348px" }}
  //               >
  //                 <Input
  //                   placeholder="Search by job title"
  //                   className="elbert-search"
  //                   value={searchQuery}
  //                   onChange={handleSearchQuery}
  //                 />
  //                 <InputGroupText>
  //                   <span className="fa fa-search"></span>
  //                 </InputGroupText>
  //               </InputGroup>
  //               <Input
  //                 type="select"
  //                 className="elbert-search"
  //                 style={{ width: "178px", marginLeft: "16px" }}
  //                 value={departmentFilter}
  //                 onChange={handleDepartmentFilter}
  //               >
  //                 <option value="">Department</option>
  //                 <option value="engineering">Engineering</option>
  //                 <option value="marketing">Marketing</option>
  //                 <option value="design">Design</option>
  //                 <option value="testing">Testing</option>
  //               </Input>
  //               <Input
  //                 type="select"
  //                 className="elbert-search"
  //                 style={{ width: "125px", marginLeft: "16px" }}
  //                 value={locationFilter}
  //                 onChange={handleLocationFilter}
  //               >
  //                 <option value="">Location</option>
  //                 <option value="newyork">New York</option>
  //                 <option value="sf">San Francisco</option>
  //                 <option value="remote">Remote</option>
  //                 <option value="onsite">Onsite</option>
  //               </Input>
  //               <Input
  //                 type="select"
  //                 className="elbert-search"
  //                 style={{ width: "125px", marginLeft: "16px" }}
  //                 value={statusFilter}
  //                 onChange={handleStatusFilter}
  //               >
  //                 <option value="">Status</option>
  //                 <option value="open">Open</option>
  //                 <option value="closed">Closed</option>
  //               </Input>
  //             </Col>
  //             <Col className="d-flex gap-3 align-items-center justify-content-end">
  //               <CustomButton text={"New Job Post"} onClick={toggleModal} />
  //             </Col>
  //           </Row>
  //           <Row className="mt-4 px-4">
  //             <Card>
  //               <CardBody>
  //                 {apiStatus.loading && <div>Loading...</div>}
  //                 {apiStatus.error && (
  //                   <div className="text-danger">{apiStatus.error}</div>
  //                 )}
  //                 <div className="table-responsive">
  //                   <Table
  //                     className="table mb-0"
  //                     style={{ border: "0.4px solid #D4D4D4" }}
  //                   >
  //                     <thead>
  //                       <tr>
  //                         <th>Job ID</th>
  //                         <th>Job Title</th>
  //                         <th>Department</th>
  //                         <th>Experience</th>
  //                         <th>Location</th>
  //                         <th>Openings</th>
  //                         <th>Applicants</th>
  //                         <th>Salary</th>
  //                         <th>Posted On</th>
  //                         <th>Expiry Date</th>
  //                         <th>Actions</th>
  //                       </tr>
  //                     </thead>
  //                     <tbody>
  //                       {jobPostingData.length > 0 ? (
  //                         jobPostingData.map((job) => (
  //                           <tr key={job.id}>
  //                             <td>{job.id}</td>
  //                             <td>{job.jobTitle}</td>
  //                             <td>{job.department}</td>
  //                             <td>{job.experienceRequiredFrom}</td>
  //                             <td>{job.jobLocation}</td>
  //                             <td>{job.noOfOpenings}</td>
  //                             <td>{job.totalCandidates}</td>
  //                             <td>{job.fromSalary}</td>
  //                             <td>{job.jobCreated}</td>
  //                             <td>{job.deadLineToApply}</td>
  //                             <td>
  //                               <div className="d-flex gap-2">
  //                                 <i
  //                                   className="fa-solid fa-eye action-icon"
  //                                   title="View"
  //                                   style={{ cursor: "pointer" }}
  //                                   onClick={() => navigate(`/job-details/${job.id}`)}
  //                                 ></i>
  //                               </div>
  //                             </td>
  //                           </tr>
  //                         ))
  //                       ) : (
  //                         <tr>
  //                           <td colSpan="11" className="text-center">
  //                             No job postings found
  //                           </td>
  //                         </tr>
  //                       )}
  //                     </tbody>
  //                   </Table>
  //                 </div>
  //               </CardBody>
  //             </Card>
  //           </Row>
  //           <CustomPagination
  //             currentPage={currentPage}
  //             totalPages={totalPages}
  //             onPageChange={handlePageChange}
  //           />
  //         </Row>
  //       </Container>
  //       <Modal
  //         style={{ width: "640px", height: "430px", borderRadius: "20px" }}
  //         isOpen={showNewJobPostModal}
  //         toggle={toggleModal}
  //         size="lg"
  //         centered
  //       >
  //         <ModalBody>
  //           <NewJobPost closeModal={toggleModal} />
  //         </ModalBody>
  //       </Modal>
  //     </div>
  //   );
  // };

  return (
    <div className="page-content">
      <PageSubHeader
        heading={"View Job Postings"}
        routePath={"Home"}
        pageName={"Job Postings"}
      />
      <Container fluid className="py-0 px-0">
        <Row className="px-4 py-4">
          <SummaryCards data={summaryData} />
          <Row className="align-items-center">
            <Col className="d-flex p-2 mx-2">
              <InputGroup
                size="sm"
                className="elbert-search-group"
                style={{ width: "348px" }}
              >
                <Input
                  placeholder="Search by job title"
                  className="elbert-search"
                  value={searchQuery}
                  onChange={handleSearchQuery}
                />
                <InputGroupText>
                  <span className="fa fa-search"></span>
                </InputGroupText>
              </InputGroup>
              <Input
                type="select"
                className="elbert-search"
                style={{ width: "178px", marginLeft: "16px" }}
                value={departmentFilter}
                onChange={handleDepartmentFilter}
              >
                <option value=""> All Departments</option>
                <option value="Engineering">Engineering</option>
                <option value="Designer">Designer</option>
                <option value="Tester">Tester</option>
                <option value="Human Resources">Human Resources</option>
                <option value="Marketing">Marketing</option>
                <option value="Software Developement & EngineeringMarketing">
                  Software Developement & Engineering
                </option>
                <option value="Product Management">Product Management</option>
                <option value="Quality Assurance(QA) & Testing">
                  Quality Assurance (QA) & Testing
                </option>
                <option value="UI/UX Design">UI/UX Design</option>
                <option value="IT & Infrastructure">IT & Infrastructure</option>
                <option value="Data Science & Analytics">
                  Data Science & Analytics
                </option>
                <option value="Cybersecurity">Cybersecurity</option>
                <option value="Sales & Business Development">
                  Sales & Business Development
                </option>
                <option value="Marketing & Digital Growth">
                  Marketing & Digital Growth
                </option>
                <option value="Human Resources (HR)">
                  Human Resources (HR)
                </option>
                <option value="Finance & Accounting">
                  Finance & Accounting
                </option>
                <option value="Customer Support & Success">
                  Customer Support & Success
                </option>
              </Input>
              {/* <Input
                type="select"
                className="elbert-search"
                style={{ width: "125px", marginLeft: "16px" }}
                value={locationFilter}
                onChange={handleLocationFilter}
              >
                <option value="">Location</option>
                <option value="Bangalore">Bangalore</option>
                <option value="sf">San Francisco</option>
                <option value="remote">Remote</option>
                <option value="onsite">Onsite</option>
              </Input> */}
              <Input
                type="select"
                className="elbert-search"
                style={{ width: "125px", marginLeft: "16px" }}
                value={statusFilter}
                onChange={handleStatusFilter}
              >
                <option value="">Status</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
              </Input>
            </Col>
            <Col className="d-flex gap-3 align-items-center justify-content-end">
              <CustomButton text={"New Job Post"} onClick={toggleModal} />
            </Col>
          </Row>
          <Row className="mt-4 px-4">
            <Card>
              <CardBody>
                {apiStatus.loading && <div>Loading...</div>}
                {apiStatus.error && !apiStatus.errorJobId && (
                  <div className="text-danger">{apiStatus.error}</div>
                )}
                <div className="table-responsive">
                  <Table
                    className="table mb-0"
                    style={{ border: "0.4px solid #D4D4D4" }}
                  >
                    <thead>
                      <tr>
                        <th>Job ID</th>
                        <th>Job Title</th>
                        <th>Department</th>
                        <th>Experience</th>
                        <th>Location</th>
                        <th>Openings</th>
                        <th>Applicants</th>
                        <th>Salary</th>
                        <th>Posted On</th>
                        <th>Expiry Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobPostingData.length > 0 ? (
                        jobPostingData.map((job) => {
                          const { label, color } = getStatusLabelAndColor(
                            job.status
                          );
                          return (
                            <tr key={job.id}>
                              <td>{job.id}</td>
                              <td
                                onClick={() =>
                                  navigate(`/job-details/${job.id}`)
                                }
                                style={{
                                  cursor: "pointer",
                                  color: "#007bff",
                                  // textDecoration: "underline",
                                }}
                                title="View Job Details"
                              >
                                {job.jobTitle}
                              </td>
                              <td>{job.department}</td>
                              <td>{job.experienceRequiredFrom}</td>
                              <td>{job.jobLocation}</td>
                              <td>{job.noOfOpenings}</td>
                              <td>{job.totalCandidates}</td>
                              <td>
                                {job.fromSalary}-{job.toSalary}
                              </td>
                              <td>{job.jobCreated}</td>
                              <td>{job.deadLineToApply}</td>
                              <td className={color}>
                                <FormGroup switch>
                                  <Label
                                    for={`jobStatus-${job.id}`}
                                    className={color}
                                  >
                                    {label}
                                  </Label>
                                  {apiStatus.error &&
                                    apiStatus.errorJobId === job.id && (
                                      <span className="text-danger">
                                        {apiStatus.error}
                                      </span>
                                    )}
                                  <Input
                                    style={{
                                      height: "1.4em",
                                      width: "3em",
                                      cursor: "pointer",
                                    }}
                                    type="switch"
                                    disabled={
                                      jobLoading[job.id] || apiStatus.loading
                                    }
                                    id={`jobStatus-${job.id}`}
                                    checked={job.status === 1}
                                    onChange={() => toggleJobStatus(job.id)}
                                  />
                                </FormGroup>
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  <i
                                    className="fa-solid fa-eye action-icon"
                                    title="View"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      navigate(`/job-details/${job.id}`)
                                    }
                                  ></i>
                                  <i
                                    className="fa-regular fa-pen-to-square action-icon"
                                    title="Edit"
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                    onClick={() =>
                                      navigate(`/create-new-job/${job.id}`)
                                    }
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No job postings found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Row>
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </Row>
      </Container>
      <Modal
        style={{ width: "640px", height: "430px", borderRadius: "20px" }}
        isOpen={showNewJobPostModal}
        toggle={toggleModal}
        size="lg"
        centered
      >
        <ModalBody>
          <NewJobPost closeModal={toggleModal} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default JobPostings;
